import React, { useState, useEffect, useRef } from 'react';
import { useInView } from '../../hooks/useInView';
import { galleryApi } from '../../services/gallery';

export const Counter = ({ totalPhotos }) => {
  const [ref, inView] = useInView(0.5);
  const [counts, setCounts] = useState([0, 0]);
  const [targets, setTargets] = useState([0, 95]); // [фото, годы]
  const run = useRef(false);
  
  const labels = ['Фотографий', 'Лет истории'];

  // 1. Определяем целевые значения
  useEffect(() => {
    if (totalPhotos !== undefined) {
      setTargets([totalPhotos, 95]);
    } else {
      // Если пропс не передан, загружаем количество с API
      galleryApi.getPhotos()
        .then(photos => setTargets([photos.length, 95]))
        .catch(err => {
          console.warn('Не удалось загрузить кол-во фото:', err);
          setTargets([0, 95]);
        });
    }
  }, [totalPhotos]);

  // 2. Запускаем анимацию только когда секция видна и данные загружены
  useEffect(() => {
    if (inView && !run.current && targets[0] > 0) {
      run.current = true;
      
      targets.forEach((t, i) => {
        let c = 0;
        const inc = t / 60; // 60 шагов анимации
        const timer = setInterval(() => {
          c += inc;
          if (c >= t) {
            c = t;
            clearInterval(timer);
          }
          setCounts(prev => {
            const n = [...prev];
            n[i] = Math.floor(c);
            return n;
          });
        }, 25);
      });
    }
  }, [inView, targets]);

  return (
    <section className="counter-section" ref={ref}>
      {counts.map((c, i) => (
        <div className="counter-item reveal visible" key={i}>
          <div className="counter-number">{c.toLocaleString()}</div>
          <div className="counter-label">{labels[i]}</div>
        </div>
      ))}
    </section>
  );
};